// HomePage.js
import React from "react";

import SlideApropo from "../../components/slideApropo";
import Mission from "../../components/mission";
import Programs from "../../components/programs";
import Flags from "../../components/flag";
import Newsletter from "../../components/newsletter";
const ApropoPage = () => {
  return (
    <div>
      <SlideApropo />
      <Mission />
      <Programs />

      <Newsletter />
    </div>
  );
};

export default ApropoPage;
